import Context from './PlayerStateContext';
import Provider from './PlayerStateProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
